import { stayDateChangeLogic } from './stayDateChangeLogic';

export const logic = [stayDateChangeLogic];
